export default `
@import url('https://fonts.googleapis.com/css?family=Source+Sans+3');
@import url('https://fonts.googleapis.com/css?family=Signika');

@page {
  size: A4;
  background: white;
  width: 14.85cm;
  display: block;
  margin: 0 auto;
  padding: 10px;
  box-shadow: 0 0 16px rgba(32, 32, 32, 0.338);
  margin-bottom: 0.5cm;
  background-image: url(https://live.staticflickr.com/65535/53501771382_8055b58acc_o.png);
  background-repeat: no-repeat;
  background-position: center bottom;
}

* {
  box-sizing: border-box;
}

body {
  background: white;
  font-size: 12px;
  line-height: 1.3;
  size: A4;
  padding-right: 20px;
  padding-left: 20px;
  display: block;
  margin: 0 auto;
  margin-bottom: 0.5cm;
}

.letter-head-nura {
  background-image: url(https://live.staticflickr.com/65535/53501771382_8055b58acc_o.png);
  background-repeat: no-repeat;
  background-position: center bottom;
  background-size: 100%;
}

.ff-signika {
  font-optical-sizing: auto;
  font-weight: 400;
  font-style: normal;
  font-variation-settings: "GRAD" 0;
}

@media print {
  body,
  @page {
    size: A4;
    margin: 0;
    box-shadow: none;
    background-color: white;
  }
}

.text-head {
  font-weight: bold;
}

.text-gray-1 {
  color: #415668;
}

.text-gray-2 {
  color: #7985A9;
}

.text-description {
  font-weight: normal;
}

.text-center {
  text-align: center;
}

.text-right {
  text-align: right !important;
}

p {
  font-size: 12px;
}

.mb-4 { margin-bottom: 4px; }
.mb-20 { margin-bottom: 20px; }
.mb-50 { margin-bottom: 50px; }
.mb-150 { margin-bottom: 150px; }

.table-normal {
  width: 100%;
  border-collapse: collapse;
  border-top: 1px solid #7AC9D0;
  border-bottom: 1px solid #7AC9D0;
}

.table-normal tr td {
  padding: 5px;
}

.table-normal thead tr th {
  border-bottom: 1px solid #7AC9D0;
  text-align: left;
  background-color: #FFFAF0;
  font-weight: normal;
}

.table-borderless {
  width: 100%;
  border-collapse: collapse;
}

.table-borderless tr td {
  padding: 5px;
  border: 0;
}

.table-borderless-footer {
  width: 100%;
  border-collapse: collapse;
}

.table-borderless-footer tr td {
  padding-top: 230px;
  border: 0;
}

.table-borderless .table-borderless tr td {
  padding: 0;
}

.v-top {
  vertical-align: top;
}

.head-box {
  text-transform: uppercase;
  text-align: center;
  color: white;
  padding: 4px;
  font-weight: 600;
}

.px-0 {
  padding-left: 0 !important;
  padding-right: 0 !important;
}

.p-0 { padding: 0 !important; }
.p-5 { padding: 5px !important; }
.d-1 { padding-right: 43px !important; }

.d-flex {
  display: flex;
}

.fs-16 {
  font-size: 16px;
}

.table-top {
  border-top: 1px solid #7AC9D0;
}

.h1 {
  font-size: 36px;
}

.hr-line {
  border-top: 1px solid #7AC9D0;
  margin: 50px 0;
}

.vl {
  border-left: 2px solid #ffc10775;
  margin-left: 20px;
}

.mt-1 { margin-top: 10px; }
.mt-2 { margin-top: 20px; }

.ff-sors-sans3 {
  color: #404F66;
}
`;
